import axios from "axios";
import { logOut } from "./redirect";
import { toast } from "react-toastify";

axios.interceptors.request.use((x) => {
   let accessToken = localStorage.getItem("access_token");
   if (accessToken) {
      x.headers.common["Authorization"] = `Bearer ${accessToken}`;
   }
   return x;
}, null);

axios.interceptors.response.use(null, (error) => {
   console.log("error", error);
   const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

   if (!expectedError) {
      toast.error("An unexpected error occurrred.");
   } else {
      switch (error.response.status) {
         case 400:
            toast.error(error?.response?.data?.Message ?? "درخواست نامعتبر است.");

            break;
         case 401:
            toast.error("خطای احراز هویت. 401");
            logOut();

            break;
         case 403:
            toast.error("دسترسی نامعتبر");

            break;
         case 404:
            toast.error("محتوایی یافت نشد");

            break;
         case 409:
            toast.error(error?.response?.data?.Message);

            break;

         default:
            toast.error(error.response.status);

            break;
      }
   }
   return Promise.reject(error);
});

const deafultAxios = {
   get: axios.get,
   post: axios.post,
   put: axios.put,
   delete: axios.delete,
};

export default deafultAxios;
